// `п. 39`: ячейка колонки «Владелец» в окне модуля.
//
// Показывается состояние связи — «активен с 01.09.2026», «приглашён», «не внесён».
// Персональных данных в ячейке нет ни для одной роли: сервер их не отдаёт.
// Ссылка на карточку человека есть **только у `root`** — у него одного сервер
// присылает номер учётной записи (`user_id`), и только он открывает чужую карточку.

import React, { FC } from "react";
import {
  IOwnerLink,
  ownerCardUserId,
  ownerLinkText,
} from "../../../utils/ownerLink";

interface OwnerCellProps {
  ownerLink?: IOwnerLink | null;
  /** Вошедший — `root`: ему показывается ссылка на карточку. */
  isRoot?: boolean;
  /** Открыть карточку человека. Без него ссылка не рисуется: нажимать некуда. */
  onOpen?: (userId: number) => void;
}

export const OwnerCell: FC<OwnerCellProps> = ({ ownerLink, isRoot, onOpen }) => {
  const text = ownerLinkText(ownerLink);
  const userId = isRoot ? ownerCardUserId(ownerLink) : null;

  if (userId === null || !onOpen) {
    return <span data-owner-state={ownerLink?.state || "none"}>{text}</span>;
  }

  return (
    <span
      data-owner-state={ownerLink?.state || "none"}
      data-owner-link={userId}
      role="link"
      tabIndex={0}
      style={{ cursor: "pointer", color: "var(--logo)" }}
      onClick={() => onOpen(userId)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") onOpen(userId);
      }}
    >
      {text}
    </span>
  );
};

export default OwnerCell;
